import { GlobalNav } from '@cox/core-ui8/dist/GlobalNav'

import { ReactGlobalNavProps } from './types'
import withAEM from '../../hoc/withAEM'

const ReactGlobalNav = (props: ReactGlobalNavProps): JSX.Element => {
  const GlobalNavWithAEM = withAEM(GlobalNav)
  return <GlobalNavWithAEM {...props} compName={'Global Nav'} />
}

export default ReactGlobalNav
